module.exports = __webpack_public_path__ + "static/img/mini.4951a06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImages/bottom/mini.jpg
// module id = UZMa
// module chunks = 3